import "./NonPeriodicPaymentInfoFieldsTableStyle.css";

import { FC, useEffect, useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { formatAmountCommaSeperator } from "../../../../common/Common";
import { InputNumber } from "primereact/inputnumber";

let columns = [
  { field: "title", headerName: "", footer:"Total Non-Periodic Payments etc"},
  { field: "total", headerName: "", footer:"0.00"},
];

interface INonPeriodicPaymentInfoFieldsTable {
  nonPeriodicTableUpdatedData: (data: any) => void;
  nonPeriodicFieldsDataItems: any;
}
export const NonPeriodicPaymentInfoFieldsTable: FC<
  INonPeriodicPaymentInfoFieldsTable
> = ({ nonPeriodicTableUpdatedData, nonPeriodicFieldsDataItems, }) => {

  const [nonPeriodicTablePayments, setNonPeriodicTablePayments] = useState<any>(
    nonPeriodicFieldsDataItems
  );

  useEffect(() => {
    nonPeriodicTableUpdatedData(nonPeriodicTablePayments);
  }, [nonPeriodicTablePayments]);

  useEffect(() => {
    setNonPeriodicTablePayments(nonPeriodicFieldsDataItems);
  }, [nonPeriodicFieldsDataItems]);


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    setNonPeriodicTablePayments((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };


  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "title") {
      return (
        <InputText
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          style={{ borderRadius: "2px", }}
        />
      );
    } else if (
      x.field === "total"
    ) {
      return (
        // <span>
        //   {rowData[x.field] !== null && rowData[x.field] !== undefined
        //     ? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
        //     : rowData[x.field]}
        // </span>
       <InputNumber
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right" }}
        />
      );
    }
    return <span>{formatAmountCommaSeperator(rowData[x.field])}</span>;
  };

  return (
    <>
      <div className="card">
        <DataTable
          value={nonPeriodicTablePayments}
          dataKey="id"
          showGridlines
          className="NonPeriodicPaymentInfoFieldsTableStyle"
          editMode="cell"
          // resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          scrollHeight="416px"
        >
          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                columnKey={x.field}
                footer={x.footer}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};
